import { render, staticRenderFns } from "./StatementCreate.vue?vue&type=template&id=032a428c"
import script from "./StatementCreate.vue?vue&type=script&lang=js"
export * from "./StatementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports